/**
 * Casilla que ademas de marcada o no puede estar "a medias": una linea con
 * algunas de sus categorias elegidas. `indeterminate` no existe como atributo
 * HTML, solo como propiedad del elemento, asi que se pone a mano.
 */
import { useEffect, useRef } from 'react';
import type { InputHTMLAttributes } from 'react';

export interface CasillaMixtaProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  mixta: boolean;
}

export function CasillaMixta({ mixta, ...propiedades }: CasillaMixtaProps) {
  const casilla = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (casilla.current !== null) casilla.current.indeterminate = mixta;
  }, [mixta]);

  return <input ref={casilla} type="checkbox" {...propiedades} />;
}
